import emailValidator from './emailValidation';
import isSonyEmail from './isSonyEmail';

export default (email = '') => {
  if (!emailValidator.test(email)) return '';
  return isSonyEmail(email) ? 'SONY' : 'PARTNER';
};
